import React from 'react';
import { grey } from 'sushiweb/tokens/color';
import './table.scss';
import { Loader } from '../loader/loader';

export const Table = ({
  tableData = {},
  tdWidth = 'auto',
  tdMaxWidth = 'auto',
  message = '',
  tableHeadBackgroundColor = '',
  dataLoading = false,
}) => {
  const headings = tableData && tableData.headings ? tableData.headings : [];
  const rows = tableData && tableData.rows ? tableData.rows : [];
  let smartplugTable =
    window.dashboard.mode === 'smartplug' ? 'smartplugTable' : '';

  if (!headings.length) return null;

  return (
    <>
      {dataLoading ? (
        <div className='tw-w-full tw-h-full tw-flex-col tw-items-center tw-justify-center tw-gap-8'>
          <Loader />
        </div>
      ) : null}
      {!dataLoading && (
        <table className={smartplugTable}>
          {headings && headings.length ? (
            <thead>
              <tr style={{ background: tableHeadBackgroundColor || grey.z200 }}>
                {headings.map(({ name }, index) => (
                  <th key={index}>{name}</th>
                ))}
              </tr>
            </thead>
          ) : null}
          <tbody>
            {rows?.length ? (
              <React.Fragment>
                {rows.map((row, index) => (
                  <React.Fragment key={index}>
                    <tr
                      className={`${
                        row?.['1']?.nestedTable?.show ? 'active' : ''
                      }`}
                    >
                      {headings.map((heading, index) => {
                        return (
                          row[heading.key] && (
                            <td
                              key={index}
                              style={{
                                maxWidth: row[heading.key].maxWidth,
                                minWidth: row[heading.key].minWidth,
                              }}
                            >
                              {row[heading.key].title && (
                                <div className='title'>
                                  {row[heading.key].title || ''}
                                </div>
                              )}
                              {row[heading.key].titleElement
                                ? row[heading.key].titleElement
                                : null}
                              {row[heading.key].subtitle && (
                                <div className='subtitle small'>
                                  {row[heading.key].subtitle}
                                </div>
                              )}
                            </td>
                          )
                        );
                      })}
                    </tr>
                    {row?.['1']?.nestedTable?.show && (
                      <tr className='nestedTable'>
                        <td colSpan={row['1'].nestedTable.colSpan}>
                          <React.Fragment>
                            {row['1'].nestedTable.data}
                          </React.Fragment>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </React.Fragment>
            ) : (
              <tr>
                <td colSpan={headings.length} className='center'>
                  {message || 'No data available.'}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </>
  );
};
